export class LoaderMessage{
    private static msgs = [
        '忍一時風平浪靜，退一步越想越氣',
        '忍一時變本加厲，退一步萬劫不復',
        '走一步算一步，實在不行死在半路',
        '成功是依靠後天的努力，所以今天跟明天先休息',
        '我以為我是紅酒，在等懂得人來品嚐；最近發現我其實是中藥，來找我的人都有病',
        '努力不一定會成功，但不努力一定很輕鬆',
        '不要害怕別人的眼光、怎麼看你，因為根本就沒人在看你',
        '今天過不好也沒關係，反正明天也不一定會過得好',
        '壓力不會成為動力，只會成為病歷',
        '適者生存，不適者在家休息',
        '世上沒有甚麼過不去的坎，如果有....一定是你的腿太短',
        '當上帝關了你一扇窗子，還會順手把你其他門窗全關了',
        '失敗了並不重要，重要的是沒成功',
        '謝謝那些曾經擊倒我的人，躺著真舒服',
        '失敗並不可怕，可怕的是有人相信這句話',
        '沒出息沒關係，有氣息就已經很棒了',
        '成功的都是領導有方，失敗的就是下屬無能',
        '兩岸猿聲啼不住，笑問客從何處來',
        '明知山有虎，別去明知山',
        '不聽老人言，快樂好幾年',
        '船到橋頭自然直，直不了就沉',
        '凡事先別慌，先拍照再說',
        '生活不只眼前的苟且，還有明天的苟且',
        '世界上沒有白走的路，只有白走的我',
        '你以為的極限，只是別人的起點；我的是終點',
        '努力到無能為力，然後躺平很有力',
        '早睡早起身體好，晚睡晚起心情好',
        '夢想還是要有的，萬一被笑就尷尬了',
        '人生像馬拉松，我一開始就搭計程車',
        '有志者事竟成，沒志者事也很多',
        '別人靠實力吃飯，我靠胃口',
        '今天不想努力，明天再說明天',
        '山不轉路轉，路不轉我轉頭就走',
        '沒有傘的孩子要奔跑，有傘的我先等雨停',
        '成年人的崩潰，從回覆「收到」開始',
        '與其內耗自己，不如外耗別人',
        '能力越大，責任越大，薪水不一定',
        '世事無常，大腸包小腸',
        '人生沒有彩排，天天都在重播',
        '吃得苦中苦，才能苦中苦',
        '把圈子變小，把脾氣變好，把體重放著就好',
        '別急著否定自己，你很特別，特別普通',
        '有些人表面風光，背地裡更風光',
        '人間清醒是少數，我是那個想睡的',
        '笑一笑十年少，笑不出來就算了',
        '條條大路通羅馬，我出生就在導航錯誤',
        '該來的總會來，不該來的外送也會來',
        '世界很大，我的床也不小',
        '做人要低調，低到查無此人',
        '一路走來沒學會別的，學會了算了',
        '別怕輸在起跑點，反正也追不上',
        '工作不會背叛你，會背叛你的是睡意',
        '我不是拖延症，我是在等待最佳時機過期',
        '你不理財，財不理你；你理我，我也未必理你',
        '與其自律三天，不如放縱一天',
        '機會是留給準備好的人，我是留給下一位',
        '別人下班是休息，我下班是續命',
        '天生我材必有用，我材可能是邊角料',
        '計畫趕不上變化，變化趕不上我不想動',
        '人要有自知之明，我有，但不多',
        '不怕神一樣的對手，只怕豬一樣的隊友和我',
        '你的努力大家都看得到，成果就不一定',
        '凡事往好處想，想不到就先吃飯',
        '理想很豐滿，現實很骨感，錢包很空靈',
        '有問題先冷靜，冷靜完問題還在',
        '做人最重要是開心，不開心就先下班',
        '轉圈不是系統卡，是人生在暖身',
        '這個 loading 很有禪意，重點是一直轉',
        '圈圈轉得比我還努力，結果都一樣',
        '正在載入你的耐心，預估無限分鐘',
        '不是頁面沒反應，是它在思考宇宙',
        '看著圈圈轉久了，連煩惱都同步旋轉',
        '資料還在路上，先讓靈魂到站',
        '每一圈都在告訴你，放下控制慾',
        '轉吧轉吧七彩霓虹燈，結果還是空白',
        'loading 不是等待，是對脾氣的壓力測試',
        '這需求很簡單，簡單到要改三個系統',
        '需求昨天提，今天上線，明天再重做',
        '時程不合理沒關係，反正工程師會魔法',
        '你說只是小改，我聽到的是全面重構',
        '這功能要快、要穩、要便宜，還要昨天完成',
        '規格寫得很清楚，清楚地什麼都沒寫',
        '客戶說不急，下一句是今天下班前',
        '這不是 bug，是需求在成長',
        '需求唯一不變的，就是一直在變',
        '先做出來再說，說完再全部推翻',
        'A 要像 B，B 要像 A，最後都不像',
        '這功能不能影響現有流程，但要全部重做',
        '請做得跟舊系統一樣，但問題也不要一樣',
        '文件寫明白了，明白到每個人都不同解讀',
        '測試環境沒問題，上線環境是另一個宇宙',
        '這需求不難，難的是說服自己它合理',
        '我們不是在開發功能，是在追需求的尾燈',
        '要完全客製化，但請套用公版不加價',
        '你說只是加按鈕，按下去卻要改宇宙',
        '交付日很明確，明確到誰都做不到',
        '請保留舊行為，同時改成全新流程',
        '別擔心風險，風險只會在上線後出現',
        '工程師寫的不是功能，是許願池',
        '我以為需求就像泡麵一樣，熱水沖下去10秒就可以吃了'
    ];
    constructor() {
    }
    prevInd = -1;
    public rand(){
        var ind = Math.floor(Math.random()*LoaderMessage.msgs.length);
        if(ind==this.prevInd){
            return this.rand();
        }
        this.prevInd = ind;
        return `「${LoaderMessage.msgs[ind]}」`;
    }
}
